module.exports = __webpack_public_path__ + "img/bd.6207ad31.svg";